/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';
import { Loader } from '..';

const GirlContainer = (props) => (
  <div className="stats__container">
    <div className="stats_text__container">
      <span className="stats_title">Short statistics</span>
      <div className="stats_conetent__container">
        <div className="stats_value__container">
          <span className="stats_value_title">Total applicants: </span>
          {props.loading ? <Loader /> : (
            <div className="stats_child__contaienr">
              <span className="stats_value">{props.applicants}</span>
              {props.weekApplicants ? (
                <span className="stats_arrived_value">
                  +
                  {props.weekApplicants}
                </span>
              ) : null}
            </div>
          )}
        </div>
        <div className="stats_value__container">
          <span className="stats_value_title">Total companies: </span>
          {props.loading ? <Loader /> : (
            <div className="stats_child__contaienr">
              <span className="stats_value">{props.companies}</span>
              {props.weekCompanies ? (
                <span className="stats_arrived_value">
                  +
                  {props.weekCompanies}
                </span>
              ) : null}
            </div>
          )}
        </div>
        <div className="stats_value__container">
          <span className="stats_value_title">Total freelancers: </span>
          {props.loading ? <Loader /> : (
            <div className="stats_child__contaienr">
              <span className="stats_value">{props.freelancers}</span>
              {props.weekFreelancers ? (
                <span className="stats_arrived_value">
                  +
                  {props.weekFreelancers}
                </span>
              ) : null}
            </div>
          )}
        </div>
        <div className="stats_value__container">
          <span className="stats_value_title">Total auditions: </span>
          {props.loading ? <Loader /> : (
            <div className="stats_child__contaienr">
              <span className="stats_value">{props.auditions}</span>
              {props.weekCastings ? (
                <span className="stats_arrived_value">
                  +
                  {props.weekCastings}
                </span>
              ) : null}
            </div>
          )}
        </div>
        <div className="stats_value__container">
          <span className="stats_value_title">Total recruiters: </span>
          {props.loading ? <Loader /> : (
            <div className="stats_child__contaienr">
              <span className="stats_value">{props.recruiters}</span>
              {props.weekRecruiters ? (
                <span className="stats_arrived_value">
                  +
                  {props.weekRecruiters}
                </span>
              ) : null}
            </div>
          )}
        </div>
      </div>
    </div>
    <div className="stats_image__container">
      <img src={require('../../images/goal.png')} alt="goal" className="stats_image" />
    </div>
  </div>
);

GirlContainer.propTypes = {
  auditions: PropTypes.number,
  freelancers: PropTypes.number,
  companies: PropTypes.number,
  applicants: PropTypes.number,
  recruiters: PropTypes.number,
  loading: PropTypes.bool,
  weekApplicants: PropTypes.number,
  weekCompanies: PropTypes.number,
  weekFreelancers: PropTypes.number,
  weekCastings: PropTypes.number,
  weekRecruiters: PropTypes.number,
};
GirlContainer.defaultProps = {
  auditions: 0,
  freelancers: 0,
  companies: 0,
  applicants: 0,
  recruiters: 0,
  loading: false,
  weekApplicants: 0,
  weekCompanies: 0,
  weekFreelancers: 0,
  weekCastings: 0,
  weekRecruiters: 0,
};

export default GirlContainer;
